import config from 'js/app/config';

const isLocalDev = () => {
  return config.environment === 'development';
};

export { isLocalDev };
